import { COLORS } from '@shared/config/colors/colors';
import { productDescriptiobQuillStyle } from '@shared/style/product-description-quill-style';
import { FormGroup } from '@vtbhome/juicyfront';
import { styled } from 'goober';
import React from 'react';

export const StyledFormGroup = styled(FormGroup)<{ $error?: string; $disabled?: boolean }>`
    .rf-form-group__message {
        ${({ $error }) => !$error && 'margin-top: 0 !important;'}
    }

    .ql-toolbar.ql-snow {
        border-radius: 8px 8px 0 0;
        ${({ $error }) => $error && `border-color: ${COLORS.error_60};`}
    }

    .ql-container.ql-snow {
        border-radius: 0 0 8px 8px;
        ${({ $error }) => $error && `border-color: ${COLORS.error_60};`}
    }

    .ql-toolbar.ql-snow,
    .ql-container.ql-snow {
        transition: background-color 0.15s ease;
        ${({ $disabled }) =>
            $disabled &&
            `
            background-color: ${COLORS.neutral_10};
            border-color: transparent;
        `}
    }
`;

export const Area = styled('div', React.forwardRef)`
    display: block;
    width: 100%;
    ${productDescriptiobQuillStyle}
`;
